<docs>
  # UiKit - Button - Icon
  > *generic way to create any icon svg cta*
</docs>
  
<script lang="ts">
import { defineComponent, PropType } from 'vue';
import UiButtonSimple from './index.vue';


const UiThemedButtonIcon = defineComponent({
  name: "UiButtonThemedIcon",
  components:{
    UiButtonSimple,
  },
  extends:UiButtonSimple,
  props:{
    theme: {
      type: String as PropType<ButtonTheme>,
      default: 'icon'
    },
    highlight: {
      type: Boolean,
      default: true,
    }
  },
});
export default UiThemedButtonIcon
</script>
  
<template>
  <ui-button-simple class="UiButtonThemed"
                    :data-theme="theme"
                    :data-variant="variant"
                    :data-dark="dark"
                    :data-selected="selected"
                    :data-highlight="highlight"
                    v-bind="$props"
  />
</template>
  
<style lang="stylus" scoped>
  [data-theme="icon"]
    f-style(button)
    position relative
    rp(padding-top, 5px)
    rp(padding-bottom, 5px)
    rp(padding-left, 15px)
    rp(padding-right, 15px)
    rp(border-radius, 5px)
    trans(all, $duration:.5s)
    &[data-dark="true"]
      addVariantHover(true)
    &[data-dark="false"]
      addVariantHover(false)

    :deep()
      .icon
        margin 0
        rp(width, 10px)
        rp(height, 10px)
        trans(color, $duration:.5s)
  </style>
  